<template>
  <div class="box-card">
    <div class="box-header">
      <h2>Informações do CCG</h2>
    </div>
    <div class="box-layout" v-for="(doc, index) in documentosCCG" :key="index">
      <div class="box-info">
        <div class="box-text">
          <strong>Data da Solicitação</strong>
          <p v-if="doc.data_solicitacao == null">-</p>
          <p v-else>{{ formatDate(doc.data_solicitacao) }}</p>
        </div>
        <div class="box-text">
          <strong>Data do Recebimento</strong>
          <p v-if="doc.data_recebimento == null">-</p>
          <p v-else>{{ formatDate(doc.data_recebimento) }}</p>
        </div>
        <div class="box-text">
          <strong>Status</strong>
          <p>{{ doc.status }}</p>
        </div>
      </div>
      <div class="box-pdf">
        <button v-on:click="formatPDF(doc.arquivo, doc.id)">
          <img
            :src="require('../assets/pdf.png')"
            alt="Baixar CCG em PDF"
            title="Baixar CCG em PDF"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { formatDate, formatPDF } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TomadorCCGPDF",
  mixins: [ViewMixin],
  props: ["docs"],
  data: () => ({
    formatDate,
    formatPDF,
    documentosCCG: [],
  }),
  
  created(){
    this.documentosCCG = this.docs;
  },
  methods: {
  },

 
};
</script>

<style lang="css" scoped>
div {
  background-color: #fff;
}

.box-card {
  border-radius: 3px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  font-size: 1rem;
}

.box-layout {
  display: flex;
  flex-direction: row;
  border: 1px solid rgba(0, 0, 0, 0.2);
  margin: 2%;
  align-items: center;
  justify-content: center;
  height: 300px;
  padding: 2%;
}

.box-info {
  display: flex;
  flex-direction: row;
  width: 60%;
  align-items: center;
  justify-content: center;
}

.box-pdf {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-text {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: #191737;
}

img {
  width: 60%;
}

button{
  transition: 0.3s opacity;
}

button:hover {
  opacity: 0.8;
}

.box-header {
  background-color: #efefef;
  height: 52px;
  padding: 16px;
  display: flex;
  align-items: center;
}

h2 {
  font-size: 14px;
  font-weight: bolder;
  color: #191737;
}

@media screen and (max-width: 800px) {
  img {
    width: 20%;
  }

  .box-layout {
    flex-direction: column;
  }

  .box-pdf {
    width: 100%;
  }
}

@media screen and (max-width: 620px) {
  .box-info {
    flex-direction: column;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorCCGPDF.vue